export const isUMSUrl = window.location.hostname.toLowerCase().startsWith("ums.");
